import React, { useEffect } from 'react';
import { View, Text, StyleSheet } from 'react-native';
import { observer } from '@legendapp/state/react';
import { globalState } from '../state/globalState';
import theme from '../config/theme';
import { AppIndexLogger } from '../utils/logger';
import { checkConnection } from '../services/network';

function HomePage() {
  // Obtém o estado do usuário e de rede
  const userState = globalState.user.get();
  const networkState = globalState.network.get();
  
  useEffect(() => {
    AppIndexLogger.Init.info('UseEffect - Página inicial inicializada');
    
    // Verificar conexão ao montar o componente
    checkConnection();
    
    return () => {
      AppIndexLogger.Main.info('Página inicial desmontada');
    };
  }, []);
  
  // Logs relacionados ao estado do usuário
  if (userState.isLoading) {
    AppIndexLogger.UserState.debug('Usuário em carregamento');
  } else if (userState.isAuthenticated) {
    AppIndexLogger.UserState.info(`Usuário autenticado: ${userState.user?.email?.split('@')[0]}`);
  } else {
    AppIndexLogger.UserState.info('Usuário não autenticado');
  }
  
  // Log de renderização
  AppIndexLogger.Render.verbose('Renderizando HomePage');
  
  return (
    <View style={styles.container}>
      <Text style={styles.title}>App Guincho Checklists</Text>
      
      {/* Status de Rede */}
      <View style={[
        styles.networkStatusContainer, 
        { backgroundColor: networkState.isConnected ? theme.colors.util.success : theme.colors.util.error }
      ]}>
        <Text style={styles.networkStatusText}>
          {networkState.isConnected 
            ? `Conectado (${networkState.connectionType || 'desconhecido'})` 
            : 'Desconectado'}
        </Text>
      </View>
      
      {userState.isLoading ? (
        <Text style={styles.statusText}>Carregando...</Text>
      ) : userState.isAuthenticated ? (
        <View style={styles.userInfoContainer}>
          <Text style={styles.welcomeText}>
            Bem-vindo, {userState.user?.email?.split('@')[0]}
          </Text>
          <Text style={styles.statusText}>
            Autenticado com sucesso!
          </Text>
        </View>
      ) : (
        <View style={styles.userInfoContainer}>
          <Text style={styles.statusText}>
            Você não está autenticado.
          </Text>
        </View>
      )}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing.lg,
    backgroundColor: theme.colors.background.primary,
  },
  title: {
    fontSize: theme.fontSizes.xxxl,
    fontWeight: theme.fontWeights.bold as any,
    color: theme.colors.primary.default,
    marginBottom: theme.spacing.xl,
  },
  userInfoContainer: {
    backgroundColor: theme.colors.background.tertiary,
    padding: theme.spacing.lg,
    borderRadius: theme.borderRadius.md,
    width: '100%',
    alignItems: 'center',
  },
  networkStatusContainer: {
    padding: theme.spacing.sm,
    borderRadius: theme.borderRadius.sm,
    marginBottom: theme.spacing.lg,
    width: '100%',
    alignItems: 'center',
  },
  networkStatusText: {
    fontSize: theme.fontSizes.md,
    fontWeight: theme.fontWeights.semibold as any,
    color: theme.colors.text.inverse,
  },
  welcomeText: {
    fontSize: theme.fontSizes.lg,
    fontWeight: theme.fontWeights.semibold as any,
    color: theme.colors.text.primary,
    marginBottom: theme.spacing.md,
  },
  statusText: {
    fontSize: theme.fontSizes.md,
    color: theme.colors.text.secondary,
  },
});

export default observer(HomePage); 